import { render, staticRenderFns } from "./CaseJewellersExhibition.vue?vue&type=template&id=56689ffb"
import script from "./CaseJewellersExhibition.vue?vue&type=script&lang=js"
export * from "./CaseJewellersExhibition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports